export default __webpack_public_path__ + "static/pomtimerdata-7246fb868bdd1b370290c2431f8d0f77.mp4";